import type { AttributeNode } from '../../types';
import { ConditionCard } from '../condition-card';
import { FieldOperatorValue } from '../condition-parts';

export function AttributeCondition({ node }: { node: AttributeNode }) {
  return (
    <ConditionCard node={node}>
      <FieldOperatorValue field={node.field} operator={node.operator} value={node.value} value2={node.value2} />
    </ConditionCard>
  );
}
